import { reduxWrapper } from "@common/redux/store";
import { Movies } from "@kursk/components/pages/Movies/Movies";
import { loadEntitiesFromQuery } from "@kursk/utils/loadEntitiesFromQuery";

export default function MoviesPage() {
  return <Movies />;
}

export const getServerSideProps = reduxWrapper.getServerSideProps(async ({ store, query }) => {
  await loadEntitiesFromQuery('movies', query, store);

  return { props: {} };
})
